
<template>
  <div class="itmform-container">
          <ValidationObserver class="needs-validation form-custom-format " v-bind:class="{'was-validated' : validated}" tag="form" ref="observer" v-slot="{passes}" @submit.prevent="onSubmitForm()">
       <XWindow ref="window" title="Delivery Scheduler" windowClass="height-auto delivery-form" scrollClass='collection height-auto' @deleteYes="emitDelete" :height="600" :width="1300" :formStatus="formStatus" @dialog-state="dialogState" :group="(group + 10)">
            <template #left-button>
<!-- 
              {{putLoading  }}--
              {{viewLoading  }}--
              {{deleteLoading  }}--
              {{formLoading  }} -->
                 <template v-if="putLoading || viewLoading || deleteLoading || formLoading">
                   <mdb-btn color="elegant" size="sm" disabled>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Loading...
                  </mdb-btn>
                </template>
                <template v-else>
                 <template v-if="isAllowed">

                  <template v-if="form.delivery.length <=0">
                    <mdb-btn color="elegant" size="sm" @click="passes(onSubmitForm('save'))">Save</mdb-btn>
                  </template>
                  <template v-if="deliveredSelectedItems.length > 0">
                    <mdb-btn color="elegant" size="sm" @click="passes(onSubmitForm('pull-out'))">Pull Out</mdb-btn>
                  </template>
                    <template v-if="form.items.length > 0">
                      <template v-if="active == 3">
                      <mdb-btn color="elegant" size="sm" @click="passes(onSubmitForm('delivery-note'))" :disabled="checkPicklistHasWarehouse > 0 ? true : false">Delivery Note</mdb-btn>
                      </template>

                    <!--  <template v-if="active == 4">
                      <mdb-btn color="elegant" size="sm" @click="passes(onSubmitForm('picklist'))" :disabled="checkPicklistHasWarehouse > 0 ? true : false">Generate Picklist</mdb-btn>
                    </template> -->
                    </template>
                  </template>
                </template>
              </template>

            <template #right-button>
              <template v-if="formStatus == 'update'">
                <template v-if="invoice.payments.length> 0">
                    <span class="invoice-balance">Total Balance : {{ $helpers.addSeparatorsNF(invoice.balance)}} QAR</span>
                </template>
              </template>

              
            </template>
            <span class="invoice-number">Sales Invoice #: {{form.series_display}}</span>

          <div class="mt-1 window-container">
           <!-- {{ activeEvent }} -->
            <mdb-tabs class="table-tabs mb-2 form" :active="active" default :links="tabs" @activeTab="getActiveTabIndex" >
              <template :slot="'form-slot'">
              <div class="window-inner-container">
                  <mdb-row class="tab-row">
                      <mdb-col col="6" class="tab-col pl-0">
  
                        <ThatsInput tabindex="2" labelClass="col-sm-4" fieldClass="col-sm-8 pl-0" label="Date" vid="date" name="date" v-model="form.transaction.date" size="sm" :disabled="true"/>
                        <ThatsInput tabindex="2" labelClass="col-sm-4" fieldClass="col-sm-8 pl-0" label="Customer" vid="name" name="name" v-model="form.transaction.attr.name" size="sm" :disabled="true"/>
                        <ThatsInput tabindex="2" labelClass="col-sm-4" fieldClass="col-sm-8 pl-0" label="Customer Mobile No." vid="mobile" name="mobile" v-model="form.transaction.attr.mobile" size="sm" :disabled="true"/>
                        <ThatsInput tabindex="2" labelClass="col-sm-4" fieldClass="col-sm-8 pl-0" label="Customer Address" vid="address" name="address" v-model="displayAddress" size="sm" :disabled="true"/>
                        <ThatsTextarea tabindex="2" labelClass="col-sm-4" fieldClass="col-sm-8 pl-0" label="Instructions" vid="instructions" name="instructions" v-model="form.transaction.attr.instructions" size="sm" :disabled="true" :rows="2"/>
                        
                      </mdb-col>    
                      <mdb-col col="6" class="tab-col pl-0">
                          <ThatsSeriesInput :show_error="showError" tabindex="1" labelClass="col-md-4" fieldClass="col-md-8 pl-0" label="Transaction ID" placeholder="Transaction ID" vid="series" name="series" v-model="form.transaction.series" :validated="validated" :rules="''" :keycode="false" size="sm" :disabled="true" />                  
                          <ThatsInput tabindex="2" labelClass="col-sm-4" fieldClass="col-sm-8 pl-0" label="Sold By" vid="sold_by" name="sold_by" v-model="form.transaction.sold_by" size="sm" :disabled="true" />
                          <ThatsInput tabindex="2" labelClass="col-sm-4" fieldClass="col-sm-8 pl-0" label="Order Status" vid="order_status" name="order_status" v-model="form.transaction.status" size="sm" :disabled="true" />
                          <ThatsInput tabindex="2" labelClass="col-sm-4" fieldClass="col-sm-8 pl-0" label="Payment Status" vid="payment_status" name="payment_status" v-model="form.transaction.attr.payment_status" size="sm" :disabled="true" />
                          <ThatsInput tabindex="2" labelClass="col-sm-4" fieldClass="col-sm-8 pl-0" label="Date Requested" vid="date_request" name="date_request" v-model="form.date" size="sm" :disabled="true" />
                          
                      </mdb-col>    
                    </mdb-row>
                </div>

                  <el-table ref="transactionItemsTable" border stripe :data="form.transaction.items" class="input-table mt-2" style="width: 100%" @selection-change="handleSelectionChange" :summary-method="getSummaries" show-summary :cell-class-name="cell" :row-key="getRowKey">
                      <el-table-column type="index" width="50" label="SQ" align="center"> </el-table-column>
                      <el-table-column label="SKU" :width="170">
                        <template slot-scope="scope">
                         <input type="text" class="form-control grid-input thats-form-control" v-model="scope.row.code" :disabled="true" />
                        </template>
                      </el-table-column>
                      <el-table-column label="Image" width="90">
                            <template slot-scope="scope">
                              <img :src="scope.row.default" style="width:90px" />
                            </template>
                          </el-table-column>
                      <el-table-column label="Item Name">
                        <template slot-scope="scope">
                          <input type="text" class="form-control grid-input thats-form-control" v-model="scope.row.name" :disabled="true" />
                        </template>
                      </el-table-column>
                        <el-table-column label="Qty" :width="70">
                          <template slot-scope="scope">
                            <input type="number" min="1" :max="scope.row.max" class="form-control grid-input thats-form-control" v-model="scope.row.qty" :disabled="true" />
                          </template>
                        </el-table-column>
                        <el-table-column label="Price" :width="100" align = "right">
                          <template slot-scope="scope">
                            <input type="text" class="form-control grid-input thats-form-control text-right" v-model="scope.row.formatted_price" :disabled="true" />
                          </template>
                        </el-table-column>
                        <el-table-column label="Amount" :width="100" align = "right">
                          <template slot-scope="scope">
                            <input type="text" class="form-control grid-input thats-form-control text-right" v-model="scope.row.amount" :disabled="true" />
                          </template>
                        </el-table-column>
                        <el-table-column label="Discount" :width="90" align = "right">
                          <template slot-scope="scope">
                            <input type="text" class="form-control grid-input thats-form-control text-right" v-model="scope.row.discount" :disabled="true" />
                            
                          </template>
                        </el-table-column>
                        <el-table-column label="Total Amount" :width="120" align = "right">
                          <template slot-scope="scope">
                            <input type="text" class="form-control grid-input thats-form-control text-right" v-model="scope.row.total" :disabled="true" />
                          </template>
                        </el-table-column>
                      <el-table-column label="Remarks">
                        <template slot-scope="scope">
                          <div v-html="scope.row.status"></div>
                          <!-- <input type="text" class="form-control grid-input thats-form-control" v-model="scope.row.remarks" :disabled="true" /> -->
                        </template>
                      </el-table-column>
                    </el-table>
              </template>
              <template :slot="'invoice-slot'">
                <div class="window-inner-container">
                  <mdb-row class="tab-row">
                     <mdb-col col="6">
                       <ThatsDatePicker :show_error="showError" tabindex="1" labelClass="col-md-4" fieldClass="col-md-8 pl-0" label="Date" placeholder="Date" vid="date" name="date" v-model="form.transaction.date" :validated="validated" :rules="'required'" size="sm" :disabled="true"/>
                       <ThatsInput tabindex="2" labelClass="col-sm-4" fieldClass="col-sm-8 pl-0" label="Customer Mobile No." vid="mobile" name="mobile" v-model="form.transaction.attr.mobile" size="sm" :disabled="true"/>
                       <ThatsInput tabindex="2" labelClass="col-sm-4" fieldClass="col-sm-8 pl-0" label="Customer Address" vid="address" name="address" v-model="form.transaction.attr.address" size="sm" :disabled="true"/>
                     </mdb-col>    
                     <mdb-col col="6">
                       
                       <ThatsInput tabindex="2" labelClass="col-sm-4" fieldClass="col-sm-8 pl-0" label="Instructions" vid="instruction" name="instruction" v-model="form.transaction.attr.instructions" size="sm" :disabled="true"/>
                       <ThatsInput tabindex="2" labelClass="col-sm-4" fieldClass="col-sm-8 pl-0" label="Other Details" vid="other_details" name="other_details" v-model="form.transaction.attr.other_details" size="sm" :disabled="true"/>
                     </mdb-col>    
                     
                   </mdb-row>
                </div> 
                  <el-table stripe :data="form.transaction.invoice.payments" class="input-table mt-2" style="width: 100%" :height="'250px'">
                    <el-table-column label="Series">
                      <template slot-scope="scope">
                        <input type="text" class="form-control grid-input thats-form-control" v-model="scope.row.series" :disabled="true"/>
                      </template>
                    </el-table-column>
                    <el-table-column label="Date">
                      <template slot-scope="scope">
                        <input type="text" class="form-control grid-input thats-form-control" v-model="scope.row.date" :disabled="true"/>
                      </template>
                    </el-table-column>
                    <el-table-column label="Mode of Payment">
                      <template slot-scope="scope">
                        <input type="text" class="form-control grid-input thats-form-control" v-model="scope.row.mode_of_payment" :disabled="true"/>
                      </template>
                    </el-table-column>
                    <el-table-column label="Payment Description" width="160">
                      <template slot-scope="scope">
                        <input type="text" class="form-control grid-input thats-form-control" v-model="scope.row.payment_method" :disabled="true"/>
                      </template>
                    </el-table-column>
                    <el-table-column label="Amount" :width="100">
                      <template slot-scope="scope">
                        <input type="text" class="form-control grid-input thats-form-control text-right" :value="scope.row.formatted_amount" :disabled="true" />
                      </template>
                    </el-table-column>
                     <el-table-column :width="100" label="Receipt">
                        <template slot-scope="scope">
                            <a href="javascript:void(0)" @click="fnPrint('/sales/receipt/'+scope.row.token_id)" color="elegant" size="sm"><span class="badge badge-dark text-uppercase">Print</span></a>
                        </template>
                    </el-table-column>
                  </el-table>

              </template>
              <template :slot="'form-attachment'">
                <div class="window-inner-container">
                  <ThatsFile labelClass="col-sm-5" fieldClass="col-sm-7 pl-0" label="Attachment" vid="sales-transaction-attachment" name="sales-transaction-attachment" v-model="form.attachment" :disabled="false" :showLabel="false" :accept="'*'"></ThatsFile>
                </div>
              </template>

              <template :slot="'pull-out-request'">
                <div class="window-inner-container">
                  <mdb-row class="tab-row">
                      <mdb-col col="6" class="tab-col pl-0">
                        <ThatsDatePicker :show_error="showError" tabindex="1" labelClass="col-md-4" fieldClass="col-md-8 pl-0" label="Pull Out Date" vid="pull_out_date" name="pull_out_date" v-model="form.date" :validated="validated" :rules="'required'" size="sm" :disabled="true"/>
                        <ThatsInput tabindex="2" labelClass="col-sm-4" fieldClass="col-sm-8 pl-0" label="Remarks" vid="remarks" name="remarks" v-model="form.description" size="sm" :disabled="false"/>
                      </mdb-col>    
                      <mdb-col col="6" class="tab-col pl-0">
                         <ThatsInput tabindex="2" labelClass="col-sm-4" fieldClass="col-sm-8 pl-0" label="Process By" vid="process_by" name="process_by" v-model="form.attr.process_by" size="sm" :disabled="true" />
                      </mdb-col>    
                    </mdb-row>
                </div>

                  <el-table ref="pulloutItemsTable" border stripe :data="deliveredItems" class="input-table mt-2" style="width: 100%" @selection-change="handleDeliveredSelectionChange" :summary-method="getDeliverySummaries" show-summary :cell-class-name="cell" :row-key="getRowKey" :key="componentKeyCounter">
                      <el-table-column type="index" width="50" label="SQ" align="center"> </el-table-column>
                      

                      <template v-if="['pullout-schedule','pullout'].includes(activeEvent.type)">
                        <el-table-column type="selection" width="35" :reserve-selection="true"> </el-table-column>
                      </template>

                      <el-table-column label="Delivery Note" :width="250">
                        <template slot-scope="scope">
                         {{scope.row.delivery_note_series}}
                        </template>
                      </el-table-column>
                      <el-table-column label="SKU" :width="150">
                        <template slot-scope="scope">
                         {{scope.row.code}}
                        </template>
                      </el-table-column>
                      <el-table-column label="Image" width="90">
                            <template slot-scope="scope">
                              <img :src="scope.row.default" style="width:90px" />
                            </template>
                          </el-table-column>
                      <el-table-column label="Item Name" width="350">
                        <template slot-scope="scope">
                          {{scope.row.name}}
                        </template>
                      </el-table-column>
                       
                        <el-table-column label="Qty" :width="120">
                          <template slot-scope="scope">
                            <input type="number" min="1" :max="scope.row.pull_out_max" v-on:change="pullOutQuantityChange(scope.row,$event)" class="form-control grid-input thats-form-control" v-model="scope.row.qty" />
                          </template>
                        </el-table-column>
                        <el-table-column label="Price" :width="100" align = "right">
                          <template slot-scope="scope">
                            {{scope.row.price | amount}}
                          </template>
                        </el-table-column>
                        <el-table-column label="Amount" :width="100" align = "right">
                          <template slot-scope="scope">
                             {{scope.row.amount | amount}}
                          </template>
                        </el-table-column>
                        <el-table-column label="Discount" :width="90" align = "right">
                          <template slot-scope="scope">
                             {{scope.row.discount | amount}}
                            
                          </template>
                        </el-table-column>
                        <el-table-column label="Total Amount" :width="110" align = "right">
                          <template slot-scope="scope">
                            {{scope.row.amount | amount}}
                          </template>
                        </el-table-column>

                        <el-table-column label="Location" :width="90" align = "left">
                          <template slot-scope="scope">
                             <input type="text" class="form-control grid-input thats-form-control text-left" style="background-color:#fff!important;" v-model="scope.row.attr.dlv_item_location"/>
                          </template>
                        </el-table-column>
                        <el-table-column label="Remarks" align = "left" width="200">
                          <template slot-scope="scope">
                           <textarea v-model="scope.row.attr.dlv_item_remarks" style="width:100%"></textarea>
                          </template>
                        </el-table-column>

                    </el-table>

                  <label class="mt-1"><strong>PULL OUT</strong></label>
                    <el-table ref="itemsTable" stripe :data="form.pull_outs" class="input-table mt-2" style="width: 100%">
                      
                      <el-table-column label="Series" width="250">
                            <template slot-scope="scope">
                              {{scope.row.series}}
                            </template>
                          </el-table-column>
                      <el-table-column label="Date" width="100">
                            <template slot-scope="scope">
                              {{scope.row.date}}
                            </template>
                          </el-table-column>
   
                      <el-table-column label="Delivery Remarks">
                        <template slot-scope="scope">
                          {{scope.row.remarks}}
                        </template>
                      </el-table-column>

                      <el-table-column label="Delivery Note" width="200" align="center">
                        <template slot-scope="scope">
                          <template v-if="scope.row.status !== 'cancelled'">
                           <mdb-btn class="m-0" @click="fnPrintDoc('/pull-out/print-note/'+scope.row.token_id)" color="elegant" size="sm">Print</mdb-btn>
                            
                           <mdb-btn class="m-0" @click="cancelPullOut(scope.row)" color="elegant" size="sm">Cancel</mdb-btn>
                          </template>
                        </template>
                      </el-table-column>

                       
                    </el-table>


              </template>
              <template :slot="'deliveries'">
                <div class="window-inner-container">
                  <mdb-row class="tab-row">
                   <mdb-col col="6" class="tab-col pl-0">
                     <ThatsInput tabindex="2" labelClass="col-sm-4" fieldClass="col-sm-8 pl-0" label="Date Requested" vid="date_request" name="date_request" v-model="form.date" size="sm" :disabled="true" />
                     
                     <span tabindex="2" label="Date Requested" vid="deliveryDate" name="deliveryDate" size="sm" data-v-5e2edc68="">
                       <div data-v-151b4b0c="" class="form-group input-group-sm row thats-form">
                         <label data-v-151b4b0c="" for="deliveryDate" class="col-form-label col-sm-4">Date Date</label>
                         <div data-v-151b4b0c="" class="col-sm-8 pl-0">
                           <mdb-row class="tab-row">
                             <mdb-col col="9" class="tab-col pl-0">
                           <ThatsDatePicker :show_error="showError" tabindex="1" labelClass="col-md-5" fieldClass="col-md-7" label="Delivery Date" vid="delivery_date" name="delivery_date" v-model="form.date" :validated="validated" :rules="'required'" size="sm" :disabled="true" :showLabel="false"/>
                             </mdb-col>
                             <mdb-col col="3" class="tab-col pr-0">
                                 <ThatsInput tabindex="2" labelClass="col-sm-4" fieldClass="col-sm-12" label="" :showLabel="false" vid="delivery_time" name="delivery_time" v-model="form.attr.time" size="sm" :disabled="false"/>
                             </mdb-col>
                           </mdb-row>
                         </div>
                       </div>
                     </span>
                     
                    <ThatsInput tabindex="2" labelClass="col-sm-4" fieldClass="col-sm-8 pl-0" label="Deliver to" vid="delivery_address" name="delivery_address" v-model="form.attr.address" size="sm" :disabled="true"/>
                     
                   </mdb-col>    
                   <mdb-col col="6" class="tab-col pl-0">
                       <ThatsInput tabindex="2" labelClass="col-sm-4" fieldClass="col-sm-8 pl-0" label="Customer Feedback" vid="customer_feedback" name="customer_feedback" v-model="form.attr.customer_feedback" size="sm" :disabled="false" />
                      <ThatsInput tabindex="2" labelClass="col-sm-4" fieldClass="col-sm-8 pl-0" label="Process By" vid="process_by" name="process_by" v-model="form.attr.process_by" size="sm" :disabled="true" />
                      <mdb-row>
                        <mdb-col col="4">
                          <mdb-btn class="m-0" @click="addAddress()" color="elegant" size="sm">Add Address</mdb-btn>
                        </mdb-col>
                      </mdb-row>
                    </mdb-col>    
                 </mdb-row>
                </div>

                   <el-table ref="deliveryItemsTable" border stripe :data="form.transaction.items" class="input-table mt-2" style="width: 100%" @selection-change="handleSelectionChange" :summary-method="getDeliverySummaries" show-summary :cell-class-name="cell" :row-key="getRowKey" :key="componentKeyCounter">
                      <el-table-column type="index" width="50" label="SQ" align="center"> </el-table-column>

                      <template v-if=" ['delivery-schedule','delivered'].includes(activeEvent.type)">
                        <el-table-column type="selection" width="35" :reserve-selection="true" :selectable="canSelectRow"> </el-table-column>
                      </template>
                      <el-table-column label="SKU" :width="150">
                        <template slot-scope="scope">
                         <input type="text" class="form-control grid-input thats-form-control" v-model="scope.row.code" :disabled="true" />
                        </template>
                      </el-table-column>
                      <el-table-column label="Image" width="90">
                            <template slot-scope="scope">
                              <img :src="scope.row.default" style="width:90px" />
                            </template>
                          </el-table-column>
                      <el-table-column label="Item Name" width="350">
                        <template slot-scope="scope">
                          {{scope.row.name}}
                        </template>
                      </el-table-column>
                        <el-table-column label="Inv. Qty" :width="75">
                          <template slot-scope="scope">
                            <input type="number" min="1" class="form-control grid-input thats-form-control" v-model="scope.row.quantity" :disabled="true" />
                          </template>
                        </el-table-column>
                        <el-table-column label="Returned" :width="75">
                          <template slot-scope="scope">
                            <input type="number" min="1" class="form-control grid-input thats-form-control" v-model="scope.row.cn" :disabled="true" />
                          </template>
                        </el-table-column>
                        <el-table-column label="Remaining Qty" :width="75">
                          <template slot-scope="scope">
                            {{ scope.row.remaining }}
                         </template>
                        </el-table-column>
                        <el-table-column label="Price" :width="100" align = "right">
                          <template slot-scope="scope">
                            <input type="text" class="form-control grid-input thats-form-control text-right" v-model="scope.row.formatted_price" :disabled="true" />
                          </template>
                        </el-table-column>
                        <el-table-column label="Amount" :width="100" align = "right">
                          <template slot-scope="scope">
                            <input type="text" class="form-control grid-input thats-form-control text-right" v-model="scope.row.amount" :disabled="true" />
                          </template>
                        </el-table-column>
                        <el-table-column label="Discount" :width="90" align = "right">
                          <template slot-scope="scope">
                            <input type="text" class="form-control grid-input thats-form-control text-right" v-model="scope.row.discount" :disabled="true" />
                            
                          </template>
                        </el-table-column>
                        <el-table-column label="Total Amount" :width="110" align = "right">
                          <template slot-scope="scope">
                            <input type="text" class="form-control grid-input thats-form-control text-right" v-model="scope.row.total" :disabled="true" />
                          </template>
                        </el-table-column>
                      <el-table-column label="Status" :width="110">
                        <template slot-scope="scope">
                          <div v-html="scope.row.status"></div>
                        </template>
                      </el-table-column>

                       <el-table-column label="Location" :width="200" align = "left">
                          <template slot-scope="scope">
                            <p>{{scope.row.dlv_item_location}}</p>
                             <template v-if="disableInput(scope.row) != true && checkIfSelected(scope.row.id)">
                              <mdb-btn class="m-0" @click="openWarehouse(scope.row,'delivery-note')" color="elegant" size="sm">SELECT</mdb-btn>
                            </template>
                          </template>
                        </el-table-column>
                        <el-table-column label="Remarks" align = "left" width="200">
                          <template slot-scope="scope">
                            <template v-if="disableInput(scope.row) !== true">
                            <textarea v-model="scope.row.dlv_item_remarks"></textarea>
                            </template>
                            <template v-else>
                              {{scope.row.dlv_item_remarks}}
                            </template>
                          </template>
                        </el-table-column>

                    </el-table> 
                    <label class="mt-1"><strong>DELIVERY NOTES</strong></label>
                 
                    <el-table ref="itemsTable" stripe :data="form.delivery" class="input-table mt-2" style="width: 100%">
                      
                      <el-table-column label="Series" width="200">
                            <template slot-scope="scope">
                              {{scope.row.series}}
                            </template>
                          </el-table-column>
                      <el-table-column label="Date" width="100">
                            <template slot-scope="scope">
                              {{scope.row.date}}
                            </template>
                          </el-table-column>
                      <el-table-column label="Item Details">
                        <template slot-scope="scope">
                          {{scope.row.delivered_items}}
                        </template>
                      </el-table-column>
                      <el-table-column label="Delivery Remarks">
                        <template slot-scope="scope">
                          {{scope.row.remarks}}
                        </template>
                      </el-table-column>
                      <el-table-column label="Delivery status">
                        <template slot-scope="scope">
                          {{scope.row.status | uppercase}}
                          <template v-if="scope.row.status === 'for-delivery' || scope.row.status === 'partial-delivery' || scope.row.status === 'for-customer-confirmation'">
                            <template v-if="scope.$index === deliveryUpdateStatusIndex && deliveryUpdateStatus === true">
                              <mdb-btn color="elegant" size="sm" disabled>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                Loading...
                              </mdb-btn>
                            </template>
                            <template v-else>
                              <mdb-btn @click="changeStatus(scope.row,scope.$index)" color="elegant" size="sm" align="left">{{ scope.row.status === 'for-customer-confirmation' ? 'Customer Confirmed ?' : 'Delivered ?' }}</mdb-btn>
                            </template>
                          </template>
                        </template>
                      </el-table-column>
                      <el-table-column label="Delivery Note" width="200" align="center">
                        <template slot-scope="scope">
                          <template v-if="scope.row.status !== 'cancelled'">
                           <mdb-btn class="m-0" @click="fnCopyDoc(scope.row.token_id)" color="elegant" size="sm">Copy</mdb-btn>
                           <mdb-btn class="m-0" @click="fnPrintDoc('/delivery/print-note/'+scope.row.token_id)" color="elegant" size="sm">Print</mdb-btn>

                           <template v-if="scope.row.attr.document.entry == null">
                            <mdb-btn class="m-0" @click="cancelDeliveryNote(scope.row.series)" color="elegant" size="sm">Cancel</mdb-btn>
                          </template>
                          </template>
                        </template>
                      </el-table-column>

                       
                    </el-table>
              </template>
              <template :slot="'picklist'">
                <div class="window-inner-container">
                  <mdb-row class="tab-row">
                   <mdb-col col="6" class="tab-col pl-0">
                     <ThatsInput tabindex="2" labelClass="col-sm-4" fieldClass="col-sm-8 pl-0" label="Date Requested" vid="date_request" name="date_request" v-model="form.date" size="sm" :disabled="true" />
                     
                     <span tabindex="2" label="Date Requested" vid="deliveryDate" name="deliveryDate" size="sm" data-v-5e2edc68="">
                       <div data-v-151b4b0c="" class="form-group input-group-sm row thats-form">
                         <label data-v-151b4b0c="" for="deliveryDate" class="col-form-label col-sm-4">Date Date</label>
                         <div data-v-151b4b0c="" class="col-sm-8 pl-0">
                           <mdb-row class="tab-row">
                             <mdb-col col="9" class="tab-col pl-0">
                           <ThatsDatePicker :show_error="showError" tabindex="1" labelClass="col-md-5" fieldClass="col-md-7" label="Delivery Date" vid="delivery_date" name="delivery_date" v-model="form.date" :validated="validated" :rules="'required'" size="sm" :disabled="true" :showLabel="false"/>
                             </mdb-col>
                             <mdb-col col="3" class="tab-col pr-0">
                                 <ThatsInput tabindex="2" labelClass="col-sm-4" fieldClass="col-sm-12" label="" :showLabel="false" vid="delivery_time" name="delivery_time" v-model="form.attr.time" size="sm" :disabled="false"/>
                             </mdb-col>
                           </mdb-row>
                         </div>
                       </div>
                     </span>
                     
                    <ThatsInput tabindex="2" labelClass="col-sm-4" fieldClass="col-sm-8 pl-0" label="Deliver to" vid="delivery_address" name="delivery_address" v-model="form.attr.address" size="sm" :disabled="false"/>
                     
                   </mdb-col>    
                   <mdb-col col="6" class="tab-col pl-0">
                       <ThatsInput tabindex="2" labelClass="col-sm-4" fieldClass="col-sm-8 pl-0" label="Customer Feedback" vid="customer_feedback" name="customer_feedback" v-model="form.attr.customer_feedback" size="sm" :disabled="false" />
                      <ThatsInput tabindex="2" labelClass="col-sm-4" fieldClass="col-sm-8 pl-0" label="Process By" vid="process_by" name="process_by" v-model="form.attr.process_by" size="sm" :disabled="true" />
                   </mdb-col>    
                 </mdb-row>
                </div>
            

                   <el-table ref="picklistItemsTable" border stripe :data="form.transaction.items" class="input-table mt-2" style="width: 100%" @selection-change="handleSelectionChange" :summary-method="getDeliverySummaries" show-summary :cell-class-name="cell" :row-key="getRowKey" :key="componentKeyCounter">
                      <el-table-column type="index" width="50" label="SQ" align="center"> </el-table-column>

                      <template v-if=" ['delivery-schedule','delivered'].includes(activeEvent.type)">
                        <el-table-column type="selection" width="35" :reserve-selection="true" :selectable="canSelectPicklistRow"> </el-table-column>
                      </template>
                      <el-table-column label="SKU" :width="150">
                        <template slot-scope="scope">
                         <input type="text" class="form-control grid-input thats-form-control" v-model="scope.row.code" :disabled="true" />
                        </template>
                      </el-table-column>
                      <el-table-column label="Image" width="90">
                            <template slot-scope="scope">
                              <img :src="scope.row.default" style="width:90px" />
                            </template>
                          </el-table-column>
                      <el-table-column label="Item Name" width="350">
                        <template slot-scope="scope">
                          {{scope.row.name}}
                        </template>
                      </el-table-column>
                        <el-table-column label="Inv. Qty" :width="75">
                          <template slot-scope="scope">
                            <input type="number" min="1" class="form-control grid-input thats-form-control" v-model="scope.row.quantity" :disabled="true" />
                          </template>
                        </el-table-column>
                        <el-table-column label="Remaining Qty" :width="75">
                          <template slot-scope="scope">
                            {{ scope.row.remaining_pick_qty }}
                            <!-- <input type="number" min="1" :max="scope.row.max" v-on:change="quantityChange(scope.row,$event)" class="form-control grid-input thats-form-control" v-model="scope.row.remaining" :disabled="disableInput(scope.row)" /> -->
                          </template>
                        </el-table-column>
                        <el-table-column label="Price" :width="100" align = "right">
                          <template slot-scope="scope">
                            <input type="text" class="form-control grid-input thats-form-control text-right" v-model="scope.row.formatted_price" :disabled="true" />
                          </template>
                        </el-table-column>
                        <el-table-column label="Amount" :width="100" align = "right">
                          <template slot-scope="scope">
                            <input type="text" class="form-control grid-input thats-form-control text-right" v-model="scope.row.amount" :disabled="true" />
                          </template>
                        </el-table-column>
                        <el-table-column label="Discount" :width="90" align = "right">
                          <template slot-scope="scope">
                            <input type="text" class="form-control grid-input thats-form-control text-right" v-model="scope.row.discount" :disabled="true" />
                            
                          </template>
                        </el-table-column>
                        <el-table-column label="Total Amount" :width="110" align = "right">
                          <template slot-scope="scope">
                            <input type="text" class="form-control grid-input thats-form-control text-right" v-model="scope.row.total" :disabled="true" />
                          </template>
                        </el-table-column>
                      <el-table-column label="Status" :width="110">
                        <template slot-scope="scope">
                          <div v-html="scope.row.status"></div>
                        </template>
                      </el-table-column>

                       <el-table-column label="Location" :width="200" align = "left">
                          <template slot-scope="scope">
                            <p>{{scope.row.dlv_item_location}}</p>
                             <template v-if="disableInput(scope.row) != true && checkIfSelected(scope.row.id)">
                              <mdb-btn class="m-0" @click="openWarehouse(scope.row,'picklist')" color="elegant" size="sm">SELECT</mdb-btn>
                            </template>
                          </template>
                        </el-table-column>
                        <el-table-column label="Remarks" align = "left" width="200">
                          <template slot-scope="scope">
                            <template v-if="disableInput(scope.row) !== true">
                            <textarea v-model="scope.row.dlv_item_remarks"></textarea>
                            </template>
                            <template v-else>
                              {{scope.row.dlv_item_remarks}}
                            </template>
                          </template>
                        </el-table-column>

                    </el-table>

                    <el-table ref="itemsTable" stripe :data="form.picklists" class="input-table mt-2" style="width: 100%">
                      
                      <el-table-column label="Series" width="200">
                            <template slot-scope="scope">
                              {{scope.row.series}}
                            </template>
                          </el-table-column>
                      <el-table-column label="Date" >
                            <template slot-scope="scope">
                              {{scope.row.date}}
                            </template>
                          </el-table-column>

                      <el-table-column label="status" width="100">
                        <template slot-scope="scope">
                          {{scope.row.status | uppercase}}
                        </template>
                      </el-table-column>
                      <el-table-column label="" width="200" align="center">
                        <template slot-scope="scope">
                          <mdb-btn class="m-0" @click="fnPrintDoc('/picklist/print/'+scope.row.series)" color="elegant" size="sm">Print</mdb-btn>
                        </template>
                      </el-table-column>

                       
                    </el-table>
                   
              </template>



              
            </mdb-tabs>
            
          </div>
       </XWindow>
          </ValidationObserver>


          <ValidationObserver class="needs-validation form-custom-format " v-bind:class="{'was-validated' : validated}" tag="form" ref="warehouseObserver" v-slot="{passes}" @submit.prevent="onSubmitWarehouseForm()">
          <el-dialog :modal="true" title="Warehouse" :visible.sync="warehouseDialog" :close-on-click-modal="false" :modal-append-to-body="true" :append-to-body="true" width="400" size="small" class="text-left select-warehouse">
            {{ selectWarehouse.series }}
          <el-table border :data="selectWarehouse.warehouses" stripe class="input-table mt-0 custom-element-table" :summary-method="getSummary" show-summary>
              <el-table-column label="Warehouse" width="250">
                  <template slot-scope="scope">
                  {{ scope.row.prefix }}

                  </template>
                  </el-table-column>
                  <el-table-column label="Stock" width="120">
                  <template slot-scope="scope">
                  {{ scope.row.stock }}

                  </template>
                  </el-table-column>
                  
                  <el-table-column label="Quantity">
                  <template slot-scope="scope">
                      <input type="text" v-model="scope.row.quantity" class="form-control" />
                  </template>
                  </el-table-column>
              </el-table>

              <ThatsInput tabindex="2" labelClass="col-sm-4" fieldClass="col-sm-8 pl-0" label="" vid="quantity" name="quantity" v-model="selectWarehouse.quantity" size="sm" :disabled="true" :show_error="true" :rules="{allowedQuantity : selectWarehouse.max}"/>

              <template slot="footer">
                <div class="p-0">
                    <div class="d-flex">
                      <template v-if="formLoading">
                        <mdb-btn color="elegant" size="sm" disabled>
                          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                          Loading...
                        </mdb-btn>
                      </template>
                      <template v-else>
                        <mdb-btn color="elegant" size="sm" @click="passes(onSubmitWarehouseForm)" :disabled="selectWarehouse.warehouses.filter((i) =>  i.quantity > 0,[]).map((i) => i.quantity,[]).reduce((a,b) => a + b,0) > 0 ? false : true">Save</mdb-btn>
                      </template>
                    </div>
                </div>
                </template>

          </el-dialog>
        </ValidationObserver>

        <el-dialog :modal="true" title="Create Delivery Note" :visible.sync="deliveryNoteConfirm.visible" :close-on-click-modal="false" :modal-append-to-body="true" :append-to-body="true" width="440" size="small" class="text-left delivery-note-confirm">

          <p class="mb-3">Create delivery note for <strong>{{ form.series_display }}</strong>?</p>

          <el-checkbox v-model="deliveryNoteConfirm.notify">Notify customer</el-checkbox>

          <template v-if="deliveryNoteConfirm.notify">
            <div class="mt-3">
              <label class="small mb-1 d-block">Customer</label>
              <div class="mb-3"><strong>{{ form.transaction.attr.name || 'Unnamed customer' }}</strong></div>

              <label class="small mb-1 d-block">Mobile</label>
              <el-input v-model="deliveryNoteConfirm.mobile" size="small" placeholder="Mobile number"></el-input>
              <small class="text-muted">Prefilled from the customer record. Edit it to notify a different number.</small>

              <label class="small mb-1 mt-3 d-block">WhatsApp preview</label>
              <div class="notify-preview">
                <div class="notify-preview-body">{{ notifyPreview }}</div>
                <div class="notify-preview-buttons">
                  <span>Confirm</span>
                  <span>Reschedule</span>
                </div>
              </div>
            </div>
          </template>

          <template slot="footer">
            <div class="p-0">
              <div class="d-flex">
                <template v-if="formLoading">
                  <mdb-btn color="elegant" size="sm" disabled>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Loading...
                  </mdb-btn>
                </template>
                <template v-else>
                  <mdb-btn color="elegant" size="sm" @click="confirmDeliveryNote">{{ deliveryNoteConfirm.notify ? 'Notify &amp; Create for Confirmation' : 'Create Delivery Note' }}</mdb-btn>
                  <mdb-btn color="grey" size="sm" @click="deliveryNoteConfirm.visible = false">Cancel</mdb-btn>
                </template>
              </div>
            </div>
          </template>

        </el-dialog>

      <!--   <AddressForm :group="(group + 1)" ref="addressForm" title="Address" :width="900" :formDataProps="form.transaction" @update="updateAddress"></AddressForm>

 -->

  <AddressDialog :group="(group + 1)" ref="addressForm" title="Address" :width="900" :formDataProps="form.transaction" @update="updateAddress"></AddressDialog>
     



  </div>
</template>
<script>
/* eslint-disable no-unused-vars */
/* eslint-disable vue/no-unused-components */
/* eslint-disable no-prototype-builtins */

import { mdbBtn,mdbContainer, mdbRow,mdbCol, mdbIcon, mdbCard, mdbTabs, mdbTab, mdbTabItem, mdbTabContent, mdbTabPane} from "mdbvue";
import { ValidationObserver, extend } from "vee-validate";
import { mapActions,mapGetters, mapMutations } from 'vuex'


import { userData } from '../../../helpers/user'
// import { isGeneralManager } from '../../helpers/headers'

import { ThatsWindow,ThatsInput, ThatsSeriesInput,ThatsPriceInput,ThatsFieldset, ThatsRadio, ThatsAutocomplete,ThatsNumber, ThatsAutosuggest,ThatsTextarea, ThatsDatePicker, ThatsMultiSelect, ThatsGridSelect, ThatsFile, ThatsBtn, ThatsCustomMultiSelect} from '../../thats/Thats.vue'
import DatePickerPage from '../../thats/DatePickerPage'
import { MessageBox, Loading } from 'element-ui';
import Fuse from 'fuse.js'
import unformat from 'accounting-js/lib/unformat.js'
import formatMoney from 'accounting-js/lib/formatMoney.js'

import Textarea from '../../thats/Textarea.vue';
import AddressDialog from './AddressDialog.vue'
import XWindow from '../../thats/XWindow.vue'
// import AddressForm from "./AddressForm.vue";
extend('allowedQuantity', {
  params: ['value'], // Define the parameter 'value' to pass the comparison value.
  validate(value, { value: comparisonValue }) {
    // Implement the validation logic.
    return value > 0 && value <= comparisonValue;
  },
  message: 'Quantity falls into negative inventory.', // Customize the error message.
});
export default {
  props : {
    group : {
      type : Number,
      default : 2
    }
  },
  inject : ['activeEventProvider'],
    components: {
        DatePickerPage,
        mdbContainer,
        mdbBtn,
        mdbRow,
        mdbCol,  
        mdbIcon,
        mdbCard,
        mdbTabs,
        mdbTab,
        mdbTabItem,
        mdbTabContent,
        mdbTabPane,
        AddressDialog,
        ValidationObserver,
        ThatsWindow, 
        ThatsInput,  
        ThatsSeriesInput,
        ThatsPriceInput,  
        ThatsFieldset,
        ThatsRadio,
        ThatsAutocomplete,
        ThatsAutosuggest,
        ThatsNumber,
        ThatsTextarea,
        ThatsDatePicker,
        ThatsMultiSelect,
        ThatsGridSelect,
        ThatsFile,
        ThatsBtn,
        ThatsCustomMultiSelect, 
        Textarea, 
        XWindow
  },
    
    data : () => ({
      printUrl : '',
      active : 0,
      warehouseDialog : false,
      deliveryNoteConfirm : {
        visible : false,
        notify : false,
        mobile : ''
      },
      validated : false,
      formOriginal : null,
      form : null,
      formLoading : false,
      response : {
        error : null,
        message : null
      },
      selected : [],
      tabs : [
                { text: 'Sales Details', slot: 'form-slot' },
                { text: 'Payments', slot: 'invoice-slot' },
                { text: 'Attachments', slot: 'form-attachment' },
                { text: 'Deliveries', slot: 'deliveries' },
                /* { text: 'Picklist', slot: 'picklist' }, */
              ],
      delivery_status : [],
      showError : false,
      deliveryUpdateStatus : false,
      deliveryUpdateStatusIndex : 0,
      deliveredItems : [],
      deliveredSelectedItems : [],
      displayAddress : null,
      selectWarehouse : {
          max : 0,
          quantity : 0,
          id : null,
          index : null,
          counter : 0,
          series : null,
          warehouses : []
      },

      componentKeyCounter : 0
    }),

  created : function() {
      var self = this;
      const formItemVar = this.formItemVar();
      if(this.formStatus == 'create'){
        this.form = this.formVar();
        
        // this.form.items.push(formItemVar);
        
       /*  this.nextCode()
         */
        this.currentDateSetter();

        
      }
       this.optionsHandler();

        const {settings} = JSON.parse(localStorage.getItem('user'));
        this.delivery_status = settings.delivery_status

        // console.log("create")

        /* if(this.formStatus === 'update'){
            if(this.form.attr.process_by === null){
                this.setPreparedBy()
            }
        } */
    },
    updated(){
      this.toggleCheck()
    },


    methods: {

      ...mapActions('ContactsModule',[ 'GetContacts' ]),
      ...mapActions('DeliveryModule',[
        'storeRecord',
        'updateRecord',
        'makePullOut',
        'deleteDeliveryNoteRecord',
        'cancelDeliveryNoteRecord',
        'changeStatusDeliveryNoteRecord',
        'filterItems',
        'updateStatus',
        'getRecord',
        'cancelPullOutRecord'
      ]),
      ...mapMutations('DeliveryModule',[
        'setFormStatusCreate',
        'setPaymentForm',
        'setFormRecord',
        'setFormStatusUpdate',
      ]),

      ...mapActions('InventoryItemMasterModule',{
        getItemRecord : 'getRecord'
      }),
      ...mapActions('PicklistModule',{
        makePicklist : 'storeRecord'
      }),



      formVar(){
        return {
          series : "",
          action : "save",
          date : "",
          attr : {
            process_by : ""
          },
          description : null,
          status : "for-delivery",
          items : [],
          attachment : [],
          transaction : {
            series : "",
            date : "",
            status_index : 0,
            status : "no-remarks",
            attr : {
              name : null,
              mobile : null,
              address : null,
              instruction : null,
              other_details : null,
              payment_status : 'no-payment',
            },
            customer : {
              name : null,
              mobile : null,
              address : null,
            },
            user_id : null,
            sold_by : null,
            customer_id : null,
            payment_method : 'cash',
            items : [],
            itm_names : [],
            attachment : [],
            invoice : {
              series : null
            },
            delivery : {
              address : null,
              time : null,
              date : null,
              remarks : null,
              status : 'for-delivery',
            }
          },
          delivery :[],
          pull_out :[],
          makeDeliveryNote : {
            series	:	null,
            date	:	null,
            attr	:	{
              process_by	:	null,
              delivery_time	:	null,
              delivery_date	:	null,
              address	:	null
            },
            status	:	"open",           
            items : []
          }
        }
      },

      formItemVar(){
        return {
                default: "",
                item_id: null,
                code: null,
                name : null,
                description: null,
                reference: null,
                qty: null,
                formatted_price: 0,
                price: 0,
                amount: 0,
                discount: 0,
                discount_type: null,
                custom_discount: {
                  apply : true,
                  discount : 0,
                  off_price : 0,
                  promo : 0,
                },
                total: 0,
                cn: 0,
                status: null,
                dlv_item_location: "",
                dlv_item_remarks: ""
              }
                      
      },
/* start */
paymentSuccess(response){
  this.setFormRecord(response.data)
  this.$emit('success')
},
updatePaymentSuccess(v){
  const self = this;

  self.getRecord({token_id : self.form.token_id}).then((response) => {
    self.active = 1
  })
},
applyDiscount(v){

  const frm = v.form;
    const qty = frm.qty;
      let price = frm.price;
      let discount = 0;
      let remarks = null;

      if(frm.promotions.length > 0 && frm.discount_type === 'promo'){
        const itemPromo = frm.promotions[0];
        frm.discount = this.computeDiscount(qty,price,itemPromo,frm.discount_type,frm.custom_discount);
        frm.remarks = this.setRemarks(qty,itemPromo);
        frm.total = this.computeTotalAmount(qty, price, frm.discount)
      }

      if(frm.discount_type === 'discount'){
        const itemPromo = frm.promotions[0];
        frm.discount = this.computeDiscount(qty,price,itemPromo,frm.discount_type,frm.custom_discount);
        frm.remarks = this.setRemarks(qty,frm.custom_discount);
        frm.total = this.computeTotalAmount(qty, price, frm.discount)
      }


   this.$set(this.form.items, v.index, frm)



    /*   if(frm.promotions.length > 0){
        const itemPromo = frm.promotions[0];
        discount = this.computeDiscount(qty,price,itemPromo,frm.discount_type,frm.custom_discount);
          remarks = this.setRemarks(qty,itemPromo);

      }

      this.$set(this.form.items[v.index], 'discount', discount)
      this.$set(this.form.items[v.index], 'remarks', remarks)
      this.$set(this.form.items[v.index], 'total', this.computeTotalAmount(qty, price, discount))
      this.$set(this.form.items[v.index], 'custom_discount', frm.custom_discount) */


},
cell({row, column, rowIndex, columnIndex}) {
  const self = this;
  if(self.formStatus === 'update'){
    if(columnIndex ===5){
        return 'cell-align-center';
      }
  }

  if(self.formStatus === 'create'){
    if(columnIndex ===6){
        return 'cell-align-center';
      }
  }
      
      return null;
},
openDiscount(index,row){
  this.setDiscountForm({index : index, form: row});
  this.$refs.discount.openDialog();
},

getSummaries(param) {
  const self = this;
        const { columns, data } = param;
        const sums = [];
        const numberColumns = [2,3,4,5,6]
        
        let totalCol = 3;
        let totalQty= 4;
        let totalPrice= 5;
        let totalAmount= 6;
        let totalDiscount= 7;
        let totalTotal= 8;

       
        columns.forEach((column, index) => {
          if (index === totalCol) {
            sums[index] = 'Total';
            return;
          }

          
          if (index === totalQty) {
            const qty = data.map(item => {
                return (item.code !== null && item.name !== null) ? parseInt(item.qty) : 0
              })

              if (!qty.every(qty => isNaN(qty))) {
                  sums[index] = qty.reduce((prev, curr) => {
                  const value = Number(curr);
                  if (!isNaN(value)) {
                    return prev + curr;
                  } else {
                    return prev;
                  }
                }, 0);
              } 
            return;
          }
         
          if (index === totalAmount) {
            const amount = data.map(item => {
                return parseInt(item.qty) * parseFloat(item.price);
              });

              if (!amount.every(amount => isNaN(amount))) {
                  const sum = amount.reduce((prev, curr) => {
                  const value = Number(curr);
                  if (!isNaN(value)) {
                    return prev + curr;
                  } else {
                    return prev;
                  }
                }, 0);

                sums[index] = this.formatNumber(sum)

              }

            return;
          }
          if (index === totalDiscount) {
            const discount = data.map(item => {
              let d = 0;
              if(item.hasOwnProperty("promotions") && item.promotions.length > 0){
                const itemPromo = item.promotions[0];
                d = self.computeDiscount(item.qty,item.price,itemPromo,item.discount_type,item.custom_discount);
              }
                return d;
              })
              
              if (!discount.every(discount => isNaN(discount))) {
                  const sum = discount.reduce((prev, curr) => {
                  const value = Number(curr);
                  if (!isNaN(value)) {
                    return prev + curr;
                  } else {
                    return prev;
                  }
                }, 0);

                sums[index] = this.formatNumber(sum)

              }
            return;
          }

          if (index === totalTotal) {
            const total = data.map(item => {
             let d = 0;
           
              
              if(item.hasOwnProperty("promotions") && item.promotions.length > 0){
                const itemPromo = item.promotions[0];
                d = this.computeDiscount(item.qty,item.price,itemPromo,item.discount_type,item.custom_discount);
              }

              if(item.discount_type === 'discount'){
                  const itemPromo = item.promotions[0];
                  d = this.computeDiscount(item.qty,item.price,itemPromo,item.discount_type,item.custom_discount);

                }


                return self.computeTotalAmountNumber(item.qty,item.price,d);
              });
              
              if (!total.every(total => isNaN(total))) {
                  const sum = total.reduce((prev, curr) => {
                  const value = Number(curr);
                  if (!isNaN(value)) {
                    return prev + curr;
                  } else {
                    return prev;
                  }
                }, 0);

                
                 this.form.total =  this.formatNumber(sum)
                sums[index] = this.formatNumber(sum)

              }

             
            return;
          }

            

          });

          // this.toggleCheck()

        return sums;
      },
  getDeliverySummaries(param) {
  const self = this;
        const { columns, data } = param;
        const sums = [];
        const numberColumns = [2,3,4,5,6]
        
        let totalCol = 4;
        let totalQty= 5;
        let totalPrice= 7;
        let totalAmount= 8;
        let totalDiscount= 9;
        let totalTotal= 10;

       
        columns.forEach((column, index) => {
          if (index === totalCol) {
            sums[index] = 'Total';
            return;
          }

          
          if (index === totalQty) {
            const qty = data.map(item => {
                return (item.code !== null && item.name !== null) ? parseInt(item.qty) : 0
              })

              if (!qty.every(qty => isNaN(qty))) {
                  sums[index] = qty.reduce((prev, curr) => {
                  const value = Number(curr);
                  if (!isNaN(value)) {
                    return prev + curr;
                  } else {
                    return prev;
                  }
                }, 0);
              } 
            return;
          }
         
          if (index === totalAmount) {
            const amount = data.map(item => {
                return parseInt(item.qty) * parseFloat(item.price);
              });

              if (!amount.every(amount => isNaN(amount))) {
                  const sum = amount.reduce((prev, curr) => {
                  const value = Number(curr);
                  if (!isNaN(value)) {
                    return prev + curr;
                  } else {
                    return prev;
                  }
                }, 0);

                sums[index] = this.formatNumber(sum)

              }

            return;
          }
          if (index === totalDiscount) {
            const discount = data.map(item => {
              let d = 0;
              if(item.hasOwnProperty("promotions") && item.promotions.length > 0){
                const itemPromo = item.promotions[0];
                d = self.computeDiscount(item.qty,item.price,itemPromo,item.discount_type,item.custom_discount);
              }
                return d;
              })
              
              if (!discount.every(discount => isNaN(discount))) {
                  const sum = discount.reduce((prev, curr) => {
                  const value = Number(curr);
                  if (!isNaN(value)) {
                    return prev + curr;
                  } else {
                    return prev;
                  }
                }, 0);

                sums[index] = this.formatNumber(sum)

              }
            return;
          }

          if (index === totalTotal) {
            const total = data.map(item => {
             let d = 0;
           
              
              if(item.hasOwnProperty("promotions") && item.promotions.length > 0){
                const itemPromo = item.promotions[0];
                d = this.computeDiscount(item.qty,item.price,itemPromo,item.discount_type,item.custom_discount);
              }

              if(item.discount_type === 'discount'){
                  const itemPromo = item.promotions[0];
                  d = this.computeDiscount(item.qty,item.price,itemPromo,item.discount_type,item.custom_discount);

                }


                return self.computeTotalAmountNumber(item.qty,item.price,d);
              });
              
              if (!total.every(total => isNaN(total))) {
                  const sum = total.reduce((prev, curr) => {
                  const value = Number(curr);
                  if (!isNaN(value)) {
                    return prev + curr;
                  } else {
                    return prev;
                  }
                }, 0);

                
                 this.form.total =  this.formatNumber(sum)
                sums[index] = this.formatNumber(sum)

              }

             
            return;
          }

            

          });

          // this.toggleCheck()

        return sums;
      },
getActiveTabIndex(index){
  this.active = index
},


optionsHandler(){
  // this.getPurchaseOrder()
  const self = this;
  // this.dispatchFilterItems({transaction_date : this.form.date})
  // self.fnGetContacts()
},
customLabel({label , mobile}){
  return `${label} – ${mobile}`
},
fnGetContacts(params){
  const self = this;
  const contacts = []
  this.GetContacts(params).then((response) => {
      if(response.length > 0){
        response.forEach((element) => {
           contacts.push({
            opt : element.label + " " + element.mobile,
            label : element.label,
            value : element.value,
            mobile : element.mobile,
            address : element.address,
          })
        })
      }
     
  })

  self.customer = contacts;
},
async setPreparedBy(){
    var self = this;
    const loggedUser = await userData()

    const frm = this.form
    frm.process_by = loggedUser.user.name
    this.form = frm;
},


deleteItem(){

  if(this.selected.length){
      if(this.formStatus === 'update'){
          MessageBox.confirm('This will permanently delete the file. Continue?', 'Warning', {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            type: 'warning'
            }).then(() => {
                this.selected.forEach(element => {
                  var removeIndex = this.form.items.map(function(item) { return item.code; }).indexOf(element.code);
                  this.form.items.splice(removeIndex, 1);
                });

                if(this.form.items.length <= 0){

                const formItemVar = this.formItemVar();
                  this.form.items.push(formItemVar)
                }
            })
      }else{
        this.selected.forEach(element => {
                  var removeIndex = this.form.items.map(function(item) { return item.code; }).indexOf(element.code);
                  this.form.items.splice(removeIndex, 1);
                });

                if(this.form.items.length <= 0){
                  const formItemVar = this.formItemVar();
                  this.form.items.push(formItemVar)
                }
      }
    

    
  }


// remove object


},

handleSelectionChange(v){
   this.form.items = v
  //  this.form.delivery_status = 'partial-delivery'
},
checkIfSelected(rowId){
  return this.form.items.filter((i) => i.id == rowId,[]).length > 0 ? true : false

},
handleDeliveredSelectionChange(v){

  console.log("deliveredSelectedItems")
  console.log(v)
  this.deliveredSelectedItems = v
},
addNewRow(index){
   /*   */

    var dataLength = this.form.items.length - 1;

    if(dataLength === index){
        const item = this.form.items[index];
        if(item.code !== null && item.description !== null){
              const formItemVar = this.formItemVar();
              this.form.items.push(formItemVar)

            }
    }

},

getSelected(v,index){
  const getSelected = this.items.filter(item => { 
        return (item.code === v)
    })[0];

    console.log(getSelected);
},

statusKeyUpFocus(){

  const localItems = this.items;
  const filterOnFocus = [];
  if(localItems.length > 0){
    localItems.forEach(item => {
      if(this.itemSeries.indexOf(item.code) < 0){
        filterOnFocus.push(item)
      }
    });

    this.items = filterOnFocus
  }

  
},

dispatchFilterItems(params){
  const results = [];
  this.filterItems(params).then((response) =>{
        if(response.length > 0){
          response.forEach(element => {
            results.push({label : element.name, code : element.series,formatted_price : element.formatted_price,price : element.sale_price, id : element.mdbID,promotions : element.promotions})
          });
        }
    })
  this.items = results

},

statusKeyUp(v){
// this.getPurchaseOrder(v)

const params = {term : v, items : this.itemSeries,transaction_date : this.form.date};
        this.dispatchFilterItems(params)
},
 openDialog(){
        this.$refs.window.openDialog();
      },
      nextCode(){
        var self = this;
      },
/* end */
      closeDialog(){
          this.$refs.window.closeDialog()
      },

      onSubmitWarehouseForm(){
        // warehouse_location
        const self = this
        this.$refs.warehouseObserver.validate().then((isValid) => {
              // console.log(isValid)

              if(isValid){

                const warehouseLocation = this.selectWarehouse.warehouses.filter((i) => i.quantity > 0,[]).map((i) => {
                  return {
                    name : i.prefix,
                    id : i.id,
                    quantity : i.quantity,
                    label : `${i.quantity} X ${i.prefix}`,
                  }
                },[])
                const index = self.form.transaction.items.findIndex(item => item.id === self.selectWarehouse.id);
                const dlv_item_location = warehouseLocation.map((i) => i.label,[]).join(",")
                self.$set(self.form.transaction.items[index], 'warehouse_location', warehouseLocation)
                self.$set(self.form.transaction.items[index], 'dlv_item_location', dlv_item_location)
                self.$set(self.form.transaction.items[index], 'remaining', self.selectWarehouse.quantity)

                self.warehouseDialog = false

              }
        });
      },
     

      onSubmitForm(action, confirmed){
        var self =this
            this.validated = true
            const isValid = this.$refs.observer.validate();
            this.showError = false
            if (isValid) {
                /* The delivery note is the one action the customer hears about, so it
                   goes through the confirmation dialog first. confirmDeliveryNote calls
                   straight back here with confirmed true to run the submit below. */
                if(action === 'delivery-note' && confirmed !== true){
                  self.openDeliveryNoteConfirm();
                  return;
                }

                // this.form.description = this.getText();
                    if(self.formLoading === false){
                      self.formLoading = true

                      if(self.formStatus == 'update'){
                        
                        self.form.action = action;

                        let deliverNoteForm = JSON.parse(JSON.stringify(self.form));

                        if(action === 'pull-out'){
                          deliverNoteForm.items = this.deliveredSelectedItems;
                           self.makePullOut(deliverNoteForm).then((response) => {
                              self.$ThatsNotify.success({
                                message : "Record was successfully updated"
                              })
                              self.$emit('success')
                              self.setFormRecord(response.data)
                              self.formLoading = false
                              self.form.items = [];

                             /*  self.$refs.pulloutItemsTable.clearSelection();
                              self.$refs.deliveryItemsTable.clearSelection();
 */
                              self.componentKeyCounter++
                            }).catch((error) => {
                              self.formLoading = false
                              self.response.error = 1;
                              if (error.response) {
                                  if(error.response.data.hasOwnProperty('errors')){
                                    self.$refs.observer.setErrors(error.response.data.errors);
                                    this.showError = true
                                  }
                                } else if (error.request) {
                                    self.response.message = error.request
                                } else {
                                    self.response.message = error.message
                                }
                                self.componentKeyCounter++
                                return;
                            })
                        }else if (action === 'picklist') {
                            console.log()
                            self.makePicklist(deliverNoteForm).then((response) => {
                              self.$ThatsNotify.success({
                                message : "Record was successfully updated"
                              })
                              self.$emit('openPicklist',response.data)
                              self.$emit('success')
                              // self.setFormRecord(response.data)
                              self.closeDialog()
                              self.formLoading = false
                              self.form.items = [];
                              self.componentKeyCounter++

                            }).catch((error) => {

                              console.log(error)
                              self.formLoading = false
                              self.response.error = 1;
                              if (error.response) {
                                  if(error.response.data.hasOwnProperty('errors')){
                                    self.$refs.observer.setErrors(error.response.data.errors);
                                    this.showError = true
                                  }
                                } else if (error.request) {
                                    self.response.message = error.request
                                } else {
                                    self.response.message = error.message
                                }

                                self.componentKeyCounter++

                                self.$ThatsNotify.warning({
                                  message : error.response.data.message,
                                  timeOut: 10000,
                                  position: 'top right'
                                })

                                
                                return;
                            }) 

                        }else{
                           if(action === 'delivery-note'){
                             deliverNoteForm.notify_customer = self.deliveryNoteConfirm.notify;
                             deliverNoteForm.notify_mobile = self.deliveryNoteConfirm.notify
                               ? self.deliveryNoteConfirm.mobile.toString().trim()
                               : null;

                             /* A notified note is not ready to be delivered - it waits on
                                the customer to confirm first. This rides on its own key
                                rather than status, because the controller reuses status for
                                the schedule and the transaction as well, and neither of
                                those is waiting on anybody. */
                             if(self.deliveryNoteConfirm.notify){
                               deliverNoteForm.delivery_note_status = 'for-customer-confirmation';
                             }
                           }

                           self.updateRecord(deliverNoteForm).then((response) => {
                              self.deliveryNoteConfirm.visible = false;

                              self.$ThatsNotify.success({
                                message : "Record was successfully updated"
                              })
                              self.$emit('success')
                              self.setFormRecord(response.data)
                              self.formLoading = false
                              self.form.items = [];
                              self.componentKeyCounter++

                            }).catch((error) => {
                              self.formLoading = false
                              self.response.error = 1;
                              if (error.response) {
                                  if(error.response.data.hasOwnProperty('errors')){
                                    self.$refs.observer.setErrors(error.response.data.errors);
                                    this.showError = true
                                  }
                                } else if (error.request) {
                                    self.response.message = error.request
                                } else {
                                    self.response.message = error.message
                                }

                                self.componentKeyCounter++
                                return;
                            })
                        }


                       /*  this.$refs.pulloutItemsTable.clearSelection();
                        this.$refs.deliveryItemsTable.clearSelection(); */


                         
                      }
                    }
                    
            }        
      },

      openDeliveryNoteConfirm(){
        const attr = (this.form.transaction && this.form.transaction.attr) ? this.form.transaction.attr : {};

        this.deliveryNoteConfirm.notify = false;
        this.deliveryNoteConfirm.mobile = (attr.mobile || '').toString().trim();
        this.deliveryNoteConfirm.visible = true;
      },

      confirmDeliveryNote(){
        /* Nothing is sent when the box is unchecked, so the number is only worth
           checking when it will actually be used. Kept loose on purpose - country
           formats vary and this only catches obvious typos. */
        if(this.deliveryNoteConfirm.notify){
          const entered = (this.deliveryNoteConfirm.mobile || '').toString().trim();

          if(entered === ''){
            this.$ThatsNotify.error({
              message : 'Enter the mobile number to notify, or uncheck Notify customer.'
            });
            return;
          }

          if(!/^\+?[0-9(][0-9\s\-()]*$/.test(entered) || entered.replace(/[^0-9]/g, '').length < 7){
            this.$ThatsNotify.error({
              message : 'That does not look like a mobile number.'
            });
            return;
          }

          this.deliveryNoteConfirm.mobile = entered;
        }

        this.onSubmitForm('delivery-note', true);
      },

      getText() {
        let text = this.$refs.descriptionEditor.$children;
        text = text.$el.innerHTML;
        return text;
      },
      FormResetter(){
        this.form = this.formVar()
        const formItemVar = this.formItemVar()
        this.form.items.push(formItemVar)
        this.setPreparedBy()
        requestAnimationFrame(() => {
              this.$refs.observer.reset();
            });
        this.validated = false
        this.formLoading = false
        this.sendLoading = false
        this.setFormStatusCreate();
        this.showError = false
        this.deliveredItems = [];
        this.deliveredSelectedItems = [];
        this.currentDateSetter();

      },
      
      currentDateSetter(){
        var MyDate = new Date();
        var date =MyDate.getFullYear()  + '-' + ('0' + (MyDate.getMonth()+1)).slice(-2) +'-'+ ('0' + MyDate.getDate()).slice(-2);
        this.form.attr.delivery_date = date;
      },
      dialogState(state){
        this.active = 0;
        this.optionsHandler();
        if(!state){
          this.FormResetter();
          return
        }

        if(this.formStatus == 'create'){
          this.FormResetter();
            this.nextCode();
        }

        this.form.items = [];

        this.componentKeyCounter++

  /*       this.$refs.pulloutItemsTable.clearSelection();
        this.$refs.deliveryItemsTable.clearSelection();
        this.$refs.picklistItemsTable.clearSelection(); */

      
        
      },
      emitDelete(){
        this.$emit('delete',this.FormRecord)
      },

      computeDiscount(qty,price,promo,discount_type,custom_discount){

/*         console.log("custom");
        console.log(custom_discount); */
        if(discount_type !== null){
          let discountPrice = 0
          let apply = false;
          let discount = 0;
            if(discount_type === 'promo'){
                apply = promo.apply
                discount = promo.discount
              }else{
                if(custom_discount !== null){
                  if(custom_discount.hasOwnProperty("apply")){
                    apply = custom_discount.apply;
                  }
                  if(custom_discount.hasOwnProperty("discount")){
                    discount = custom_discount.discount;
                  }
                }
              
              
            }
           const p = parseFloat(price) * qty;
                
                  if(apply === true){
                    discountPrice = parseFloat(p) * (discount / 100);
                  }else{
                    discountPrice = parseFloat(discount) * qty;
                  }
          return discountPrice;
        }
        return 0;
      },
     

      setRemarks(qty,promo){
          if(promo.apply === true){
              return `${promo.discount}% Discount`;
          }else{
            return `${this.formatNumber(((promo.discount) * qty))} QAR Off`;
          }
      },
      computeAmount(qty,price){
          return this.formatNumber((qty * parseFloat(price)));
      },
      computeTotalAmountNumber(qty,price,discount){
        const d = parseFloat(discount);
        const amount = qty * parseFloat(price);
        const totalAmount = amount - d;
          return ((d > 0) ? totalAmount : amount);
      },
      computeTotalAmount(qty,price,discount){
        const d = parseFloat(discount);
        const amount = qty * parseFloat(price);
        const totalAmount = amount - d;
          return this.formatNumber(((d > 0) ? totalAmount : amount));
      },

      calculate(index){
        const self = this;
          if(typeof self.form.items[index] !== 'undefined') {
              const item = self.form.items[index];
              
              let discount = 0;
              let remarks = null;

              if(item.promotions.length > 0){
                  const itemPromo = item.promotions[0];
                  discount = this.computeDiscount(item.qty,item.price,itemPromo,item.discount_type,item.custom_discount);
                  remarks = this.setRemarks(item.qty,itemPromo)
                }

                if(item.discount_type === 'discount'){
                  const itemPromo = item.promotions[0];
                  discount = this.computeDiscount(item.qty,item.price,itemPromo,item.discount_type,item.custom_discount);
                  remarks = this.setRemarks(item.qty,item.custom_discount);
                  // frm.total = this.computeTotalAmount(qty, price, frm.discount)
                }

                
              if(item.code !== null && item.name !== null){
                 const amount = this.computeAmount(item.qty,item.price);
                 const totalAmount = this.computeTotalAmount(item.qty,item.price,discount);
                 this.$set(self.form.items[index], 'remarks',remarks)
                 this.$set(self.form.items[index], 'discount', this.formatNumber(discount))
                 this.$set(self.form.items[index], 'amount', amount)
                 this.$set(self.form.items[index], 'total', totalAmount)

              }
          }
      },

      formatNumber(n) {
        return parseFloat(n).toFixed(2).replace(/./g, function(c, i, a) {
          return i > 0 && c !== "." && (a.length - i) % 3 === 0 ? "," + c : c;
        });
      },
      fnPrint(url){
        // this.printUrl = url
          const windowHeight =  window.innerHeight;
          const innerWidth =  window.innerWidth;

         var strWindowFeatures = "location=yes,height="+windowHeight+",width="+innerWidth+",scrollbars=yes,status=yes";
        const win = window.open(url, "_blank", strWindowFeatures);
        win.document.title = 'Print';
        win.print()

        // this.$refs.printWindow.openDialog();
      },
      fnPrintDoc(url){
        // this.printUrl = url
          const windowHeight =  window.innerHeight;
          const innerWidth =  window.innerWidth;

         var strWindowFeatures = "location=yes,height="+windowHeight+",width="+innerWidth+",scrollbars=yes,status=yes";
        const win = window.open(`${url}`, "_blank", strWindowFeatures);
        win.document.title = 'Print';
        win.print()

        // this.$refs.printWindow.openDialog();
      },
      
      getDeliveryStatusSelected(v){
        console.log(v)
      },

      toggleCheck(){
        const self = this;


        if(this.form.transaction.hasOwnProperty('items') && this.form.transaction.items.length > 0){
          const getCode = this.form.items.map(i => i.code);
          if(getCode.length > 0){
              self.$nextTick(() => {
                self.form.transaction.items.forEach((item,index) => {
                    if(getCode.includes(item.code)){
                      self.$refs.itemsTable.toggleRowSelection(item,true);
                      // alert(index)
                    }
                })

              })

               
                
              }else{
                self.$refs.itemsTable.clearSelection();
              } 

          // const indexZero = this.form.transaction.items[0];
          //     this.$refs.itemsTable.toggleRowSelection(indexZero);

        
        }
      },

      getRowKey(row){
        return row.id
      },

      getQtyForDelivery(code){
        // console.log(this.formOriginal)

        const getItemFormOriginal = this.formOriginal.items.filter((i) => {

          // console.log(i)
          return i.code === code
        })[0];


        // const this.formOriginal.items.
        /* if(typeof this.formOriginal.items[index] !== 'undefined'){
            return this.formOriginal.items[index].qty
        }
        return 0; */
/* 
        console.log("qty")
        console.log(code)
        console.log(getItemFormOriginal) */
      },

      quantityChange(v){
        // console.log(v)
        const code = v.code;
        const qty = parseInt(v.remaining);
          if(qty > v.max){
              v.remaining = v.max;
          }
          if(qty < 0){
            v.remaining = 0;
          }
      },
      
      pullOutQuantityChange(v){
        // console.log(v)
        const code = v.code;
        const qty = parseInt(v.qty);
          if(qty > v.pull_out_max){
              v.qty = v.pull_out_max;
          }
          if(qty < 0){
            v.qty = 0;
          }
      },

      createDeliveryNote(){

      },

      canSelectRow(row, index){
        if(row.remaining <= 0){
           return false
        }
        return true;
        },
      canSelectPicklistRow(row, index){
        if(row.remaining_pick_qty <= 0){
           return false
        }
        return true;
        },
      disableInput(row){
        // console.log(row)
        if(row.remaining <= 0){
           return true
        }
        return false;
        },

        deleteDeliveryNote(series,row){
          const self = this;
            const deliveryNoteRow = [{...row}];
            MessageBox.confirm('This will permanently delete the delivery note. Are you sure you want to continue?', 'Warning', {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            type: 'warning'
            }).then(() => {
              self.deleteDeliveryNoteRecord({series : series,rows: deliveryNoteRow}).then((response) => {
                  self.setFormRecord(response.data)
              })
            })

        },
        cancelDeliveryNote(series){
          const self = this;
            // const deliveryNoteRow = [{...row}];
            MessageBox.confirm('Are you sure you want to cancel delivery note?', 'Warning', {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            type: 'warning'
            }).then(() => {
              self.cancelDeliveryNoteRecord(series).then((response) => {
                  self.setFormRecord(response.data)
              })
            })

        },
        cancelPullOut(object, token){
          const self = this;

          console.log("object")
          console.log(object)
            // const deliveryNoteRow = [{...row}];
            MessageBox.confirm('Are you sure you want to cancel?', 'Warning', {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            type: 'warning'
            }).then(() => {
              self.cancelPullOutRecord({"obj" : object, "token_id" : object.token_id, series : object.series}).then((response) => {
                  self.setFormRecord(response.data)
              })
            })

        },
        changeStatus(row, index){
          const self = this;

       
          self.deliveryUpdateStatusIndex = index

            /* Awaiting confirmation goes straight to delivered for now - there is no
               separate confirmed state yet, so the customer's word is what closes it. */
            const changeStatusMessage = row.status === 'for-customer-confirmation'
              ? 'This will record the customer as having confirmed and change status to delivered. Are you sure you want to continue?'
              : 'This will change status to delivered. Are you sure you want to continue?';

            MessageBox.confirm(changeStatusMessage, 'Warning', {
              confirmButtonText: 'OK',
              cancelButtonText: 'Cancel',
              type: 'warning'
            }).then(() => {
              self.deliveryUpdateStatus = true; 
              self.changeStatusDeliveryNoteRecord({...row,status : 'delivered'}).then((response) => {
                self.deliveryUpdateStatus = false;
                const updateRow = {...row,status : 'delivered'};
                self.$set(self.form.delivery,index,updateRow)

                  self.$ThatsNotify.success({
                                message : "Record was successfully updated"
                              })

              })
            })
        },

        fnCopyDoc(token_id){
          const self = this;
          const formDelivery = this.form.delivery.filter((item) => {
            return (item.token_id == token_id);
          })[0];

          console.log(token_id)
          console.log(formDelivery)
          var txt = "";
          //txt += "demo\ttest\ndemo\ttest\n";

          // const fTxt = txt;

          if(formDelivery){
                if(formDelivery.items.length > 0){
                  formDelivery.items.forEach(element => {
                      txt += self.form.date+"\t"+self.form.series_display+"\t"+element.code+"\t"+element.name+"\t"+element.qty+"\t"+formDelivery.date+"\n"
                  });
                }
          }
          console.log(formDelivery)
          console.log(txt)
              var dummy = document.createElement("textarea");
              document.body.appendChild(dummy);
              dummy.setAttribute("id", "dummy_id");
              document.getElementById("dummy_id").value=txt;
              dummy.select();
              document.execCommand("copy");
              document.body.removeChild(dummy);
        },
        openWarehouse(row,windowType){
            const self = this;
            if(self.selectWarehouse.id != row.id){

              const loading = Loading.service({
                  fullscreen: true ,
                  text: 'Loading',
                  spinner: 'el-icon-loading',
                  background: 'rgba(255, 255, 255, 0.7)'
              });
  
              console.log(row)
              
             
              self.selectWarehouse = {
                  max : 0,
                  quantity : 0,
                  id : null,
                  index : null,
                  series : null,
                  warehouses : [],
                  windowType: windowType
                }
              this.getItemRecord({series : row.code}).then((res) => {
                  loading.close();
                  self.selectWarehouse = {
                    id : row.id,
                    quantity : (windowType == 'delivery-note') ? row.remaining : row.remaining_pick_qty,
                    max :  (windowType == 'delivery-note') ? row.max : row.max_pick_qty, 
                    series : row.code,
                    index : row.sort - 1,
                    warehouses : res.warehouses,
                    windowType: windowType
                  }
                  self.warehouseDialog = true
              }).catch(() => {
                loading.close();
              })
            }else{
              self.warehouseDialog = true
            }


          
        },
        getSummary(param){
      const self = this;
      const { columns, data } = param;
      const sums = [];
      columns.forEach((_column, index) => {



        if (index === 0) {
          sums[index] = 'Total';
          return;
        }
        if (index === 2) {
          const qty = data.map(item => {
              return parseInt(item.quantity)
            })

            if (!qty.every(qty => isNaN(qty))) {
                sums[index] = qty.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
            }
          return;
        }

        });

        // this.toggleCheck()

      return sums;
    },

    addAddress(){
      this.$refs.addressForm.openDialog();
    },
    updateAddress(v){
          console.log("update Address")
          console.log(v)


           let add = ""
                     add += (v.attr.address != "" && v.attr.address !== null) ? v.attr.address  : "";

                    add += (v.attr.address2.street != "" && v.attr.address2.street !== null) ? ","+v.attr.address2.street  : "";
                    add += (v.attr.address2.building!= "" && v.attr.address2.building!== null) ? ","+v.attr.address2.building : "";
                    add += (v.attr.address2.zone != "" && v.attr.address2.zone !== null) ? ","+v.attr.address2.zone  : "";
                    add += (v.attr.address2.area != "" && v.attr.address2.area !== null) ? "/"+v.attr.address2.area  : "";
                    add += (v.attr.address2.city != "" && v.attr.address2.city !== null) ? "/"+v.attr.address2.city  : "";

                    this.form.attr.address = add.trim();

      },

    },

    computed: {

      ...mapGetters('DeliveryModule',
      [
        'putLoading',
        'formStatus',
        'formRecord',
        'viewLoading',
        'deleteLoading',
      ]),
      
...mapGetters('AuthModule',[ 'user', ]),

      checkPicklistHasWarehouse(){
        return this.form.items.filter((item) => {
              return item.warehouse_location.length <= 0 
          },[]).length
      },

      itemSeries : function(){
          var self = this;
          const filteredSeries = self.form.items.filter((item) => {
              return (item.code !== "" && item.code !== null)
          }).map(function(key){
                return key.code
          })


          return filteredSeries;
      },

      disabled : function(){
          var self = this;
          /* if(self.formStatus === 'update'){
            if(self.form.invoice !== null && self.form.invoice.series !== null){
              return true;
            }
          } */
          return false;
      },
      /**
       * The body of tl_delivery_confirmation as the customer will read it.
       *
       * Rendered here rather than fetched because the delivery note does not
       * exist yet at this point - the dialog is what creates it. Keep the wording
       * in step with delivery_caption in the api's config/whatsapp-v25.php; the
       * template itself can only be changed at Meta.
       */
      notifyPreview : function(){
        const value = (candidate, fallback) => {
          const text = (candidate === null || candidate === undefined) ? '' : String(candidate).trim();
          return text === '' ? fallback : text;
        };

        const customer = value(this.form.transaction.attr.name, 'N/A');
        const invoice = value(this.form.series_display, 'N/A');
        const address = value(this.form.attr.address, value(this.form.transaction.attr.address, 'N/A'));

        let date = 'N/A';
        const raw = this.form.attr.delivery_date;

        if(raw){
          const parsed = new Date(raw);

          if(!isNaN(parsed.getTime())){
            // "October 1, 2026", the shape the approved example uses.
            date = parsed.toLocaleDateString('en-US', { year : 'numeric', month : 'long', day : 'numeric' });
          }
        }

        return `Hi ${customer},\n\nDelivery address: ${address}\nInvoice: ${invoice}\nScheduled delivery date: ${date}\n\nPlease confirm if the scheduled delivery time works for you. Thank you!`;
      },

      invoice : function(){
          let inv = {
          series : "",
          date : "",
          balance : 0,
          paid : 0,
          attachment : [],
          payments : [],
        }

        /* if(this.formStatus == 'update'){
            if(this.FormRecord.transactions != null && this.FormRecord.transactions.invoice !== null){
              inv = this.FormRecord.transactions.invoice
            }

        } */
        return inv
      },
      isAllowed : function(){
            if(this.$helpers.isDeliveryTeam() || this.$helpers.isSystemAdministrator()){
                return true
            }
            return false;
        },

      btnText : function(){
          if(this.form.items.length > 0){
              return "Delivery Note";
          }
          return "Save";
      },

      activeEvent : function(){
        return this.activeEventProvider()
      }

      /* deliveredItems : function(){
        if(this.form.hasOwnProperty('delivery') && this.form.delivery.length > 0){
              const deliveredItem = this.form.delivery.filter((item) => {
                return item.status === 'delivered';
              },[]);
              let deliveredItems = []
              if(deliveredItem.length > 0){

                const hasPullOutTab = this.tabs.filter((i) => {
                  return i.slot === 'pull-out-request'
                },[]);

                if(hasPullOutTab.length <= 0){

                      deliveredItem.forEach(element => {
                        console.log(element.items)
                              element.items.forEach(innerElement => {

                                console.log(innerElement)
                                    deliveredItems.push({...innerElement,delivery_note_series : element.series});
                              });
                      });
                }
              }

              return deliveredItems;
          }

          return [];
      } */
    },

    watch: {
      formRecord : function(v){
        const self = this;
        this.active = (['pullout','pullout-schedule'].includes(this.activeEvent.type)) ? 4 : 3;

      
        
        if(this.formStatus == 'update'){

          const jsonParse = JSON.parse(JSON.stringify(v));
          
          jsonParse.attr = {...this.form.attr,...jsonParse.attr}


          if(Object.prototype.hasOwnProperty.call(jsonParse.attr,"address") && jsonParse.attr.address === null){
              jsonParse.attr.address =  jsonParse.transaction.attr.address;
          }

          if(jsonParse.attr.process_by === null){
              const loggedUser = userData()
              jsonParse.attr.process_by = loggedUser.user.name;
          }

   
          if(jsonParse.hasOwnProperty('delivery') && jsonParse.delivery.length > 0){

            console.log("formRecordx")
            console.log(v)


              const deliveredItem = jsonParse.delivery.filter((item) => {
                return item.status !== 'cancelled';
              },[]);



              if(deliveredItem.length > 0){

                const hasPullOutTab = this.tabs.filter((i) => {
                  return i.slot === 'pull-out-request'
                },[]);

                if(hasPullOutTab.length <= 0){
                  this.tabs.push({ text: 'Pullout Request', slot: 'pull-out-request' })


                }

                  let deliveredItems = []

                   deliveredItem.forEach(element => {
                            
                                  element.items.forEach(innerElement => {
                                        const getItem = jsonParse.transaction.items.filter((i) => {
                                            return i.id == innerElement.transaction_item_id;
                                        },[]);

                                        console.log("getItem")
                                        console.log(getItem)
                                        if(getItem.length > 0){
                                          const getRowItem = getItem[0];
                                          
                                          const deliveredItem = {...innerElement,delivery_note_series : element.series, pull_out_max : innerElement.qty, price : getRowItem.price, amount: getRowItem.amount,discount : getRowItem.discount, total : getRowItem.total};
                                          console.log(deliveredItem)
                                          deliveredItems.push(deliveredItem);
                                        }
                                    
                                  });
                          });


                    console.log("lorem")
                    console.log(deliveredItems)

                  this.deliveredItems = JSON.parse(JSON.stringify(deliveredItems));



              }
          }

          jsonParse.status = 'delivered';

          const transactionAttr = jsonParse.transaction.attr

          let add = ""
                     add += (transactionAttr.address != "" && transactionAttr.address !== null) ? transactionAttr.address  : ""; 

                    add += (transactionAttr.address2.street != "" && transactionAttr.address2.street !== null) ? ","+transactionAttr.address2.street  : ""; 
                    add += (transactionAttr.address2.building!= "" && transactionAttr.address2.building!== null) ? ","+transactionAttr.address2.building : ""; 
                    add += (transactionAttr.address2.zone != "" && transactionAttr.address2.zone !== null) ? ","+transactionAttr.address2.zone  : ""; 
                    add += (transactionAttr.address2.area != "" && transactionAttr.address2.area !== null) ? "/"+transactionAttr.address2.area  : ""; 
                    add += (transactionAttr.address2.city != "" && transactionAttr.address2.city !== null && typeof transactionAttr.address2.city !== 'undefined') ? "/"+transactionAttr.address2.city  : ""; 

                  this.displayAddress = add.trim();

          jsonParse.attr.address = add.trim();
          jsonParse.attr.delivery_date = jsonParse.date;

          if(jsonParse.transaction.hasOwnProperty('items') && jsonParse.transaction.items.length){
            jsonParse.transaction.items = jsonParse.transaction.items.map((i) => {
              return {...i,warehouse_location : [],dlv_item_location : null}
            })
            this.form = jsonParse;
          }


          if(this.form.transaction.hasOwnProperty('items') && this.form.transaction.items.length){

            this.toggleCheck()
          }
          if(this.form.items.length > 0){
              this.selected = this.form.items.map(i => i.code);
          }

          self.formOriginal = JSON.parse(JSON.stringify(jsonParse))
          this.componentKeyCounter++
        }

        if(this.formStatus == 'create'){
          this.FormResetter();
        }
      },

      'form.items' : {
          handler: function(v) {
            if(v.length > 0){
              const total = v.map((i) => {
                return unformat(i.total);
              }).reduce((a,b) => {
                return a + b;
              })
              this.form.total = formatMoney(total, { symbol: "", precision: 2, thousand: ",", decimal: "." });
            }

          },
          deep: true
      },
      'selectWarehouse.warehouses' : {
          handler: function(v) {
            if(v.length > 0){
              const total = v.map((i) => {
                return unformat(i.quantity);
              }).reduce((a,b) => {
                return a + b;
              })
              this.selectWarehouse.quantity = total;
            }

          },
          deep: true
      },

      'form.attachment' : {
        handler : function(v){
            // alert("attachment")
        },
        deep: true
      }

    },


}
</script>

<style scoped>
.notify-preview{
  background: #e7ffdb;
  border-radius: 6px;
  padding: 8px 10px;
  font-size: 12px;
  line-height: 1.4;
}
.notify-preview-body{
  /* The template's own line breaks are part of the message. */
  white-space: pre-wrap;
}
.notify-preview-buttons{
  display: flex;
  margin-top: 8px;
  padding-top: 6px;
  border-top: 1px solid rgba(0,0,0,.08);
}
.notify-preview-buttons span{
  flex: 1;
  text-align: center;
  color: #1f7aec;
  padding: 3px 0;
}
.click-to-add-logo{
  font-size: 14px;cursor: pointer;
}



.custom-control {
    position: absolute!important;
    margin: 10px!important;
}

.custom-control.image-delete{
  right: 0;cursor: pointer;
}

.custom-checkbox .custom-control-label::before {
    border-radius: .50rem!important;cursor: pointer;
}

.no-image-gallery{
  padding: 65px;
  text-align: center;
}

.no-image-gallery i.far {
  font-size: 42px;
  color: #959595;
}
a.discount-a{
  margin : 5px;
}

.tab-content{
  height: auto!important;
}
</style>
